module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/$.is-object.js
// module id = 519
// module chunks = 0